export default __webpack_public_path__ + "static/media/fox.90bfba83.png";